import { useEffect } from "react";
import { useLocation , useNavigate } from "react-router-dom";

export const PaymentIframe = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // extract query param
  const queryParams = new URLSearchParams(location.search);
  const paymentUrl = queryParams.get("url");

   useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/Agent/Booking"); 
    }, 30000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <>
        {/* <div style={{ height: "500px", width: "100%" }}>
      <iframe
        src={src}
        width="100%"
        height="100%"
        title="Example Website"
        style={{ border: "none" }}
      ></iframe>
    </div> */}

     <div style={{ height: "100vh", width: "100%" }}>
      {paymentUrl ? (
        <iframe
          src={paymentUrl}
          width="100%"
          height="100%"
          title="Payment Page"
          style={{ border: "none" }}
        ></iframe>
      ) : (
        <p>Loading payment...</p>
      )}
    </div>
    </>
  )
}
